import {
  Button,
  Inline,
  Modal,
  type ModalProps,
  Typography,
} from '@omnipresentgroup/design-system';
import type { ReactElement } from 'react';

type ConfirmationModalProps = {
  modalProps: Omit<ModalProps, 'children'>;
  handleConfirm: () => void;
  handleCancel: () => void;
  description: string | ReactElement;
  loading?: boolean;
};

export const MODAL_TITLE = 'Are you sure?';

export const ConfirmationModal = (props: ConfirmationModalProps) => {
  const { modalProps, description, loading, handleCancel, handleConfirm } =
    props;

  return (
    <Modal {...modalProps} span={3}>
      <Modal.Header title={MODAL_TITLE} />

      <Modal.Body>
        {typeof description === 'string' ? (
          <Typography as="span" size="14" color="subtle">
            {description}
          </Typography>
        ) : (
          description
        )}
      </Modal.Body>

      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button variant="secondary" onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm} loading={loading}>
            Yes
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
